import { FormField, Text } from '@/_components';
import {
  CardContainer,
  FormMediaInput,
  ImageTextHeader,
  PageHeaderCtrlContainer,
  StatusButtonInput,
  useMedia,
} from '@/_containers';
import { PageHeaderContainer } from '@/_containers/headers/page/page-header-container';
import type { OnPartialUpdate } from '@/_schemas/types';
import { nameResolver } from '@/_shared';

import { useTeamMemberFormContext } from '../../form-context';
import type { TeamMemberUpdateSchema } from '../../schemas';

export function Header({
  onUpdate,
  isPending,
  isEditable,
}: {
  isEditable: boolean;
  isPending: boolean;
  onUpdate: OnPartialUpdate<TeamMemberUpdateSchema>;
}) {
  const form = useTeamMemberFormContext();

  const [first_name, last_name, id, job_title] = form.watch(['first_name', 'last_name', 'id', 'job_title']);

  const folder_path = `team-members/${id}`;

  const { onImageUpdate } = useMedia(onUpdate);

  return (
    <CardContainer bodyClassName="flex">
      <PageHeaderContainer>
        <ImageTextHeader
          imageSlot={
            <FormField
              control={form.control}
              name="profile_image"
              render={({ field: { ref: _, ...field } }) => (
                <FormMediaInput
                  {...field}
                  size="lg"
                  shape="circle"
                  label=""
                  disabled={!isEditable}
                  folder_path={folder_path}
                  onImageStateChange={onImageUpdate}
                />
              )}
            />
          }
          primarySlot={nameResolver(first_name, last_name)}
          secondarySlot={
            <Text as="small" className="text-c-card-muted mt-0.5 font-normal">
              {job_title || ''}
            </Text>
          }
          tertiarySlot={
            <PageHeaderCtrlContainer>
              <StatusButtonInput isPending={isPending} onUpdate={onUpdate} />
            </PageHeaderCtrlContainer>
          }
        />
      </PageHeaderContainer>
    </CardContainer>
  );
}
